import React from "react";
import { getImgPath } from "../common/helper";

import {
  t,
  TAB5_HEADING1,
  TAB5_HEADING2,
  TAB5_LI1,
  TAB5_LI2,
  TAB5_LI3,
  TAB5_LI4,
  TAB5_LI5,
  TAB5_LI6,
  TAB5_LI7,
  TAB5_LI8,
} from "../../translations/AboutUs/BusServiceAiravat";

function BusServiceAiravat() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <div style={{ fontSize: 20, fontWeight: 600, textAlign: "left" }}>
        {t(TAB5_HEADING1)}
      </div>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <div>
          <img src={getImgPath("/img/aboutus/bus_service/bus5.png")} alt="" />
        </div>
      </div>
      <div style={{ fontSize: 16, fontWeight: 600, textAlign: "left" }}>
        {t(TAB5_HEADING2)}
      </div>
      <div>
        <ul style={{ margin: 0, padding: 0, marginLeft: 48 }}>
          <li style={{ fontSize: "14px", fontWeight: 400 }}>{t(TAB5_LI1)}</li>
          <li style={{ fontSize: "14px", fontWeight: 400 }}>{t(TAB5_LI2)}</li>
          <li style={{ fontSize: "14px", fontWeight: 400 }}>{t(TAB5_LI3)}</li>
          <li style={{ fontSize: "14px", fontWeight: 400 }}>{t(TAB5_LI4)}</li>
          <li style={{ fontSize: "14px", fontWeight: 400 }}>{t(TAB5_LI5)}</li>
          <li style={{ fontSize: "14px", fontWeight: 400 }}>{t(TAB5_LI6)}</li>
          <li style={{ fontSize: "14px", fontWeight: 400 }}>{t(TAB5_LI7)}</li>
          <li style={{ fontSize: "14px", fontWeight: 400 }}>{t(TAB5_LI8)}</li>
        </ul>
      </div>
    </div>
  );
}

export default BusServiceAiravat;
